import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=c2e8c806&scoped=true"
import script from "./PostEdit.vue?vue&type=script&lang=js"
export * from "./PostEdit.vue?vue&type=script&lang=js"
import style0 from "./PostEdit.vue?vue&type=style&index=0&id=c2e8c806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e8c806",
  null
  
)

export default component.exports